module.exports = __webpack_public_path__ + "static/media/company-logo-horizontal.e0ac917a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-logo-horizontal.png
// module id = 104
// module chunks = 0